import ProviderBasicSearchIndex from './components/provider-basic-search-index';

export default ProviderBasicSearchIndex;
